import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch, useAppSelector} from "../../../../../../../../app/hooks";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";
import {
    TERMS_TITLE_MAX_LENGTH,
    TermsTitleValidator,
    UrlValidator
} from "../../../../../../../elements/validator/Validator";
import {
    selectShowTerms,
    selectTermsTitle,
    selectTermsUrl,
    updateLocalizedField,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";

const TERMS_URL_MAX_LENGTH = 2048;

interface TermsViewProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const TermsView: React.FC<TermsViewProps> = ({
                                                        getMessageWrapper,
                                                        updateValidationStatus
                                                    }) => {
    const dispatch = useAppDispatch();
    const showTerms = useAppSelector(selectShowTerms);

    return <AppearanceTabSettingsContainer
        title="Terms Link"
        withSwitch={true}
        switchValue={showTerms}
        onSwitchChange={(v) => dispatch(updateSettings({
            showTerms: v
        }))}
    >
        {showTerms && <div className={styles.fieldsLine}>
            <ValidatedInputField
                onChange={(v) => dispatch(updateLocalizedField({
                    field: "termsTitle",
                    value: v
                }))}
                updateValidationStatus={updateValidationStatus}
                fieldName="termsTitle"
                selector={selectTermsTitle}
                validator={TermsTitleValidator}
                label="Title"
                maxLength={TERMS_TITLE_MAX_LENGTH}
                placeholder="e.g., Terms & Conditions"
                getMessage={getMessageWrapper}
            />
            <ValidatedInputField
                onChange={(v) => dispatch(updateLocalizedField({
                    field: "termsUrl",
                    value: v
                }))}
                updateValidationStatus={updateValidationStatus}
                fieldName="termsUrl"
                selector={selectTermsUrl}
                validator={UrlValidator}
                label="Link"
                maxLength={TERMS_URL_MAX_LENGTH}
                placeholder="https://"
                getMessage={getMessageWrapper}
            />
        </div>
        }
    </AppearanceTabSettingsContainer>
}
